import { Component, ViewEncapsulation, output, input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import '@asn/icon';

@Component({
    selector: 'ap-hamburger',
    templateUrl: './hamburger.component.html',
    styleUrls: ['./hamburger.component.scss'],
    encapsulation: ViewEncapsulation.None,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApHamburgerComponent {
    /**
     * Is hamburger menu open?
     * Defaults to false
     */
    public readonly isOpen = input(false);

    /**
     * Emits event if menu is toggled
     */
    public readonly toggleMenu = output<void>();
}
